import { load } from './loader';
import * as gototopButton from './modules/gototopButton';
import * as lazyLoad from './modules/imageLazyload';

load([
  gototopButton,
  lazyLoad
]);
